import { GoATable } from "@abgov/react-components";
import * as React from "react";
import { IFlyingHours } from "../../../model/IFlyingHours";
interface IViewFlyingDetailProps {
    flyingHours: IFlyingHours[];
}

const ViewFlyingDetail: React.FunctionComponent<IViewFlyingDetailProps> = ({
    flyingHours,
    ...props
}) => {
    const calculateTotalFlyingHours = () => {
        var totalFlyingHours = 0;

        if (flyingHours) {
            flyingHours.forEach((record) => {
                totalFlyingHours += record.noOfUnits ?? 0;
            });
            return totalFlyingHours.toFixed(1);
        } else {
            return totalFlyingHours;
        }
    };
    return (
        <div className="white-background horizontal-scrollbar">
            <GoATable width="100%">
                <thead>
                    <tr style={{ position: "sticky", top: 0 }}>
                        <th className="width145px">Fire number</th>
                        <th className="width230px">Crew type on board</th>
                        <th className="width230px">Activity</th>
                        <th className="width120px">Rate type</th>
                        <th className="width120px">No.of units</th>
                        <th className="width110px">Unit</th>
                        <th className="width140px">Rate per unit</th>
                        <th className="width150px">Cost</th>
                        <th className="width150px">Internal order</th>
                        <th className="width150px">Cost centre</th>
                        <th className="width80px">Fund</th>
                        <th className="width100px">Account</th>
                        <th className="width150px">Invoice no.</th>
                    </tr>
                </thead>

                <tbody>
                    {flyingHours.length > 0 &&
                        flyingHours
                            .filter((x) => !x.deleted)
                            .map((record: IFlyingHours, idx: number) => (
                                <tr key={idx}>
                                    <td>
                                        {record?.fireNumberEntity &&
                                        record?.fireYear
                                            ? record?.fireNumberEntity
                                                  ?.fireNumber +
                                              "-" +
                                              record?.fireYear
                                            : record?.fireNumberEntity
                                              ? record?.fireNumberEntity
                                                    ?.fireNumber
                                              : ""}
                                    </td>
                                    <td>
                                        {record?.crewTypeEntity
                                            ? record?.crewTypeEntity?.code +
                                              "-" +
                                              record?.crewTypeEntity
                                                  ?.description
                                            : ""}
                                    </td>
                                    <td>
                                        {record?.costingActivityEntity
                                            ? record?.costingActivityEntity
                                                  ?.code +
                                              " " +
                                              record?.costingActivityEntity
                                                  .description
                                            : ""}
                                    </td>
                                    <td>
                                        {record?.rateTypeEntity
                                            ? record?.rateTypeEntity?.type
                                            : ""}
                                    </td>
                                    <td>{record?.noOfUnits.toFixed(1)}</td>
                                    <td>
                                        {record?.rateUnitEntity
                                            ? record?.rateUnitEntity?.type
                                            : ""}
                                    </td>
                                    <td>
                                        {"$" + record?.ratePerUnit?.toFixed(2)}
                                    </td>
                                    <td>{"$" + record?.cost.toFixed(2)}</td>
                                    <td>{record?.internalOrder}</td>
                                    <td>{record?.costCenter}</td>
                                    <td>{record?.fund}</td>
                                    <td>{record?.account}</td>
                                    <td>{record?.invoiceNumber}</td>
                                </tr>
                            ))}

                    {/* Total flying hours row */}
                    <tr>
                        <td colSpan={2}></td>
                        <td colSpan={2} className="text-right">
                            {"Total flying hours"}
                        </td>
                        <td colSpan={9} className="fontBold">
                            {calculateTotalFlyingHours()}
                        </td>
                    </tr>
                </tbody>
            </GoATable>
        </div>
    );
};

export default ViewFlyingDetail;
